//--------------------------------------------
//
// Random Users
//
//--------------------------------------------
'use strict';

import q from 'q';

//fallback in case AJAX fails
import PEOPLE from './People';


let DATA = [];


const RandomUser = () => {
	const self = this;
	const deferred = q.defer();
	


	if (DATA.length >  0){
		deferred.resolve(DATA[Math.floor(Math.random() * DATA.length)]);
	}

	else{

		const request = new XMLHttpRequest();
		let data = null;

		request.open('GET', 'data/people.json');


		request.onload = () => {
			if (request.status >= 200 && request.status < 400){
				data = JSON.parse(request.responseText);

				for (let i = 0; i < data.length; i++ ){
					DATA.push(data[i]);
				}

				deferred.resolve(DATA[Math.floor(Math.random() * DATA.length)]);
			}

			else{
				console.log('Error fetching user data');
			}
		}

		request.onerror = (err) => {
			deferred.reject(err);
		}

		request.send();

	}

	return deferred.promise;
}


export default RandomUser;